import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { replaceCurly } from '@bingads-webui-campaign/fluctuation-common';
import { FluctuationUrlService } from '../fluctuation-url-service';

export class DetailContainer extends React.PureComponent {
  getUrl = (detail) => {
    const urlService = new FluctuationUrlService(this.props.deps.azure);
    const nestUrlCapableIds = ['KeywordTab', 'AdGroupSettingsTab', 'CampaignSettingsTab'];
    const context = _.contains(nestUrlCapableIds, detail.UrlId) ?
      _.extend(this.props.context, {
        CampaignId: detail.Values[0],
        AdGroupId: detail.Values[1],
        UserId: this.props.deps.context.CurrentUser.Id,
      }) :
      this.props.context;
    return replaceCurly(
      urlService.getUrl(this.props.details[0].UrlId),
      context,
      detail.Values
    );
  };

  render() {
    const detailsDom = this.props.details.map((detail, index) => {
      const nestUrlCapableIds = ['AdGroupTab', 'KeywordTab', 'AdGroupSettingsTab', 'CampaignSettingsTab'];
      if (_.contains(nestUrlCapableIds, detail.UrlId)) {
        const linkUrl = this.getUrl(detail);
        const onClickObj = _.extend(detail, {
          linkUrl,
        });
        const localizedDisplayName = this.props.deps.i18n.getString(detail.DisplayName) ||
          detail.DisplayName;
        /* eslint-disable jsx-a11y/click-events-have-key-events,
          jsx-a11y/no-static-element-interactions */
        /* eslint-disable react/no-array-index-key */
        return (
          <div
            className="entity-entry"
            key={`${detail.UrlId}${detail.DisplayName}${index}`}
            onClick={() => { this.props.onLinkClicked(onClickObj); }}
          >
            <a href={this.getUrl(detail)} target="_blank" rel="noopener noreferrer">{localizedDisplayName}</a>
          </div>
        );
      }
      /* eslint-disable react/no-array-index-key */
      return <div className="entity-entry" key={`${detail.UrlId}${index}${this.props.expandedEntityName}`}>{detail.Values[0]}</div>;
    });
    return (
      <div className="detail-container-wrapper">
        <div className="entity-header">
          {`${this.props.expandedEntityName}:`}
        </div>
        <div>
          {detailsDom}
        </div>
      </div>
    );
  }
}

DetailContainer.propTypes = {
  deps: PropTypes.shape({
    context: PropTypes.shape({
      CurrentUser: PropTypes.shape({
        Id: PropTypes.number,
        IsInternal: PropTypes.bool,
      }),
      CurrentCustomer: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentAccount: PropTypes.shape({
        Id: PropTypes.number,
      }),
    }).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    userActionActivity: PropTypes.shape({
      trace: PropTypes.func,
    }).isRequired,
    azure: PropTypes.shape({}).isRequired,
  }).isRequired,
  onLinkClicked: PropTypes.func.isRequired,
  cause: PropTypes.shape({
    Message: PropTypes.shape({
      MessageId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  context: PropTypes.shape({
    CustomerId: PropTypes.number,
    AccountId: PropTypes.number,
    CampaignId: PropTypes.number,
    AdGroupId: PropTypes.number,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    RootCauseId: PropTypes.number,
    UrlId: PropTypes.string,
    Type: PropTypes.string,
    Message: PropTypes.shape({
      Id: PropTypes.string,
    }),
  })).isRequired,
  expandedEntityName: PropTypes.string.isRequired,
};
